import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Plus, X } from "lucide-react";

import FetalMbtiLauncher from "../etc/FetalMbtiLauncher";
import ChatbotLauncher from "../chatbot/ChatbotLauncher";
import PregnancyQuizLauncher from "../etc/PregnancyQuizLauncher";
import BabyNameGeneratorLauncher from "../etc/BabyNameGeneratorLauncher";

function FloatingItem({ open, delay = 0, children }) {
  return (
    <div
      className={[
        "transition-all duration-300 ease-out",
        open
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0 h-0 overflow-hidden",
      ].join(" ")}
      style={{ transitionDelay: open ? `${delay}ms` : "0ms" }}
    >
      {children}
    </div>
  );
}

export default function FloatingLaunchers() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      {open ? (
        <button
          type="button"
          aria-label="플로팅 메뉴 닫기"
          className="fixed inset-0 z-[998] bg-black/20"
          onClick={() => setOpen(false)}
        />
      ) : null}

      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-10 md:right-10 z-[999] flex flex-col items-center gap-4">
        <FloatingItem open={open} delay={0}>
          <ChatbotLauncher />
        </FloatingItem>

        <FloatingItem open={open} delay={60}>
          <BabyNameGeneratorLauncher />
        </FloatingItem>

        <FloatingItem open={open} delay={120}>
          <FetalMbtiLauncher />
        </FloatingItem>

        <FloatingItem open={open} delay={180}>
          <PregnancyQuizLauncher />
        </FloatingItem>

        <button
          type="button"
          aria-label={open ? "플로팅 메뉴 닫기" : "플로팅 메뉴 열기"}
          onClick={() => setOpen((prev) => !prev)}
          className="
            flex h-16 w-16
            sm:h-24 sm:w-24
            md:h-28 md:w-28
            items-center justify-center rounded-full
            bg-[linear-gradient(135deg,#ffb347_0%,#ff9601_100%)]
            text-white
            shadow-[0_0_24px_rgba(255,150,1,0.5),0_12px_30px_rgba(0,0,0,0.28)]
            transition-transform duration-200 active:scale-95
          "
        >
          {open ? (
            <X
              className="h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14"
              strokeWidth={2.2}
            />
          ) : (
            <Plus
              className="h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14"
              strokeWidth={2.2}
            />
          )}
        </button>
      </div>
    </>
  );
}
